import React from 'react';
import { Box, Typography, Link, Grid, useTheme } from '@mui/material';
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CodeIcon from "@mui/icons-material/Code";
import Footer from './footer';

function ContactSection() {
  const theme = useTheme();

  const textColor = theme.palette.mode === 'dark' ? '#f5f5f5' : '#333333';
  const text2color = theme.palette.mode === 'dark' ? '#f50057' : '#f50057';
  const linkColors = theme.palette.mode === 'dark' ? '#2196F3' : '#2196F3';

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" align="center" gutterBottom sx={{ textDecoration: 'underline' }}>
        CONTACT ME VIA THE FOLLOWING
      </Typography>
      <Box sx={{ marginTop: 5}}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <Typography variant="body1" gutterBottom sx={{ color: textColor }}>
              <AccountCircleIcon sx={{ marginRight: 1 }} />
              <strong>Name:</strong>{" "}
              <Typography component="span" sx={{ color: text2color }}>EVERLYNE AKINYI</Typography>
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: textColor }}>
              <EmailIcon sx={{ marginRight: 1 }} />
              <strong>Email:</strong>{" "}
              <Typography component="span" sx={{ color: text2color }}>evahaudi2354@gmail.com</Typography>
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: textColor }}>
              <PhoneIcon sx={{ marginRight: 1 }} />
              <strong>Mobile Number:</strong>{" "}
              <Typography component="span" sx={{ color: text2color }}>+254 7917 46140</Typography>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1" gutterBottom sx={{ color: textColor }}>
              <CodeIcon sx={{ marginRight: 1 }} />
              <strong>Designation:</strong>{" "}
              <Typography component="span" sx={{ color: text2color }}>software developer</Typography>
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: textColor }}>
              <LinkedInIcon sx={{ marginRight: 1 }} />
              <strong>LinkedIn:</strong>{" "}
              <Link href="https://www.linkedin.com/in/everlyne-akinyi90683a1b5/" target="_blank"  sx={{ color: linkColors }}>
                linkedin.com/in/everlyne-akinyi90683a1b5
              </Link>
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: textColor }}>
              <GitHubIcon sx={{ marginRight: 1 }} />
              <strong>GitHub:</strong>{" "}
              <Link href="https://github.com/evahaudi" target="_blank"  sx={{ color: linkColors }}>
                github.com/evahaudi
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
}

export default ContactSection;
